import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    UpgradeHelper, IJourneyItem,AdminToolPanelHelper, EJourneyToolSearchType,AdminToolHelper,IAdminToolPanel
} from '../../../helpers';
import { Search } from '../../common/search';
import { PanelHeader } from '../../admintool/panelheader';
declare var jQuery;

interface IProps {
    adminToolState: any;
    searchState: any;
    panelName: string;
    isDisplayed: boolean;
    journeyToolSearchType?: EJourneyToolSearchType;
}
export class UpgradeJourneySearch extends React.Component<IProps, any> {
    
    private searchField:HTMLInputElement = null;
    private refocusOnBlur: boolean = false;

    componentDidMount() {
        this.searchField = jQuery((ReactDOM.findDOMNode(this))).find(".panel-content input")[0] as HTMLInputElement;
        AdminToolPanelHelper.SetUpPanelState(this.props.adminToolState, this.props.panelName, this.props.isDisplayed);
    }

    updateSearchResults = (searchTerm: string) => {
        AdminToolHelper.GetJourneyByTerms(this.props.adminToolState.processList[this.props.adminToolState.tab],searchTerm);
    }
    render() {
        let { upgradeJourneysResults, sharedJourneyTerm } = this.props.searchState;
        let panel:IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
        let displayed: boolean = AdminToolPanelHelper.IsPanelDisplayed(panel);
        let searchBoxValue = jQuery(".searchupgradejourneys .search input").val();

        return (<div className="searchupgradejourneys admintool-panelcontainer">
            <PanelHeader panelName={this.props.panelName} panelTitle={"Search for journeys"} enableToggle={true} isEnabled={this.props.isDisplayed} adminToolState={this.props.adminToolState} />
            <div className="panel-content" style={!displayed ? { display: 'none' } : {}}>
                <Search
                    journeyToolSearchType={this.props.journeyToolSearchType}
                    results={upgradeJourneysResults}
                    searchTerm={searchBoxValue}
                    labelText={'Search for journeys'}
                    showResultsWithEmptyTerm={false}
                    isCurrentSearchComponent={true}
                    awaitingResults={false}
                    debounceDelay={1000}
                    adminToolSearch={true}
                    updateResults={(a) => { this.updateSearchResults(a) }}
                    onBlur={() => {

                        if(this.refocusOnBlur) {
                            this.refocusOnBlur = false;
                            this.searchField.focus();
                        }
                        else {
                            this.searchField.value = "";
                            this.updateSearchResults("");
                        }
                        
                    }}
                    onResultClick={(key, item: IJourneyItem) => {

                        this.refocusOnBlur = true;

                        this.searchField.focus();
                        
                        if (key && this.props.adminToolState.processList[this.props.adminToolState.tab].filter(a => a.journeyId == key).length == 0) {
                            let selectKey:string = "#"+key;
                            jQuery(selectKey+ " .journeyversion").text("In the list");
                            jQuery(selectKey+"").addClass("journeyinlist");
                            jQuery(selectKey+"").removeClass("journeynotinlist");
                            let journeyItemList: IJourneyItem[] = [];
                            journeyItemList.push(item);
                            AdminToolHelper.AddToProccessList(journeyItemList);
                        }
                    }}
                />
            </div>
        </div>
        );
    }
}  



// WEBPACK FOOTER //
// ./source/ts/components/admintool/panels/upgradejourneysearch.tsx